export default __webpack_public_path__ + "static/media/8.903fe8c9.png";